export type SearchableFieldExtractor<T> = (item: T) => (string | undefined)[];

export const filterBySearchQuery = <T>(
  items: T[],
  searchQuery: string,
  extractSearchableFields: SearchableFieldExtractor<T>,
): T[] => {
  const normalizedQuery: string = searchQuery?.toLowerCase().trim();

  if (!normalizedQuery) {
    return items;
  }

  return items.filter((item: T): boolean => {
    const fields: (string | undefined)[] = extractSearchableFields(item);
    return fields.some(
      (field: string | undefined): boolean =>
        field?.toLowerCase().includes(normalizedQuery) ?? false,
    );
  });
};
